import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import About from '../components/About';
import SEO from '../components/SEO';
import { doctorInfo } from '../data/mock';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO title="About" path="/about" description="Dr. Venkata Pradeep Babu Koyyala - Medical Oncologist with DrNB from RGCI New Delhi. Director & CEO of Shankara Cancer and Research Institute, Tezpur. EC Member ISMPO, Executive Secretary NESMO." keywords="Dr Koyyala Background, Medical Oncologist Tezpur, DrNB Medical Oncology, Cancer Doctor Assam" />
      <Navigation />
      
      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 bg-gradient-to-b from-teal-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            About Dr. Koyyala
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Bringing world-class cancer care to Northeast India with compassion and expertise
          </p>
        </div>
      </div>

      {/* About Content */}
      <About />

      {/* Additional Detailed Biography */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Professional Journey</h2>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              Dr. Venkata Pradeep Babu Koyyala's journey in oncology is marked by dedication to both clinical excellence and advancing medical knowledge. After completing his MBBS from Andhra Medical College, Visakhapatnam, he pursued MD in General Medicine, followed by DrNB in Medical Oncology from the prestigious Rajiv Gandhi Cancer Institute and Research Center, New Delhi.
            </p>

            <p className="text-gray-700 leading-relaxed mb-6">
              His commitment to staying at the forefront of oncology led him to pursue multiple international fellowships and training programs. Notably, he completed the ESMO Community Fellowship in Integrated Oncology and Palliative Care at Princess Margaret Cancer Center, Toronto, Canada - one of the world's leading cancer centers. This experience shaped his holistic approach to cancer care, emphasizing not just treatment but also quality of life.
            </p>

            <p className="text-gray-700 leading-relaxed mb-6">
              Dr. Koyyala has also earned the European Society certification in Medical Oncology (ECMO) from Barcelona, Spain, and completed the ESMO International Mentorship Program under Dr. Peter Vuylsteke in the Netherlands. His specialized training includes breast cancer management, immuno-oncology, and molecular oncology of colorectal cancers through the UICC Fellowship program.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Leadership in Oncology Organizations</h3>
            
            <div className="bg-teal-50 rounded-xl p-6 mb-6">
              <p className="text-gray-800 mb-4">
                <strong className="text-teal-900">EC Member, ISMPO:</strong> As an Executive Committee member of the Indian Society of Medical and Pediatric Oncologists, Dr. Koyyala contributes to shaping oncology practices and policies across India.
              </p>
              <p className="text-gray-800">
                <strong className="text-teal-900">Executive Secretary, NESMO:</strong> Leading the North East Society of Medical and Pediatric Oncologists, he works to improve cancer care accessibility and quality throughout Northeast India.
              </p>
            </div>

            <p className="text-gray-700 leading-relaxed mb-6">
              Beyond clinical practice, Dr. Koyyala is a prolific researcher and educator. He has published over 112 papers and case reports, authored book chapters, and even edited a comprehensive textbook for oncology students. His research interests span multiple areas including breast cancer, immuno-oncology, gastrointestinal malignancies, and early cancer detection.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Community Impact</h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Understanding that cancer care extends beyond the clinic, Dr. Koyyala has initiated several community projects:
            </p>

            <ul className="space-y-3 mb-6">
              <li className="text-gray-700">
                <strong className="text-teal-700">PROJECT SMART PINK:</strong> A breast cancer screening initiative aimed at screening 1000 women using mammography and Thermalytix technology through partnership with Rotary Club of Tezpur.
              </li>
              <li className="text-gray-700">
                <strong className="text-teal-700">PROJECT SOUNDARYA:</strong> Provides hair wigs to women experiencing hair loss during chemotherapy, helping restore confidence and dignity.
              </li>
              <li className="text-gray-700">
                <strong className="text-teal-700">PROJECT ANNAPURNA:</strong> Ensures cancer patients and their attendants receive proper nutritional support during treatment.
              </li>
            </ul>

            <p className="text-gray-700 leading-relaxed">
              In recognition of his patient-centric approach and community service, Dr. Koyyala received the prestigious MINA BHUYAN FOUNDATION AWARD 2023 for being a "People Friendly Doctor" in Assam.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;